import OnScreen from 'onscreen';

export default {
    init() {
        const os = new OnScreen();
        os.on('enter', '.add_fadeInUp ', (element) => {
            if (element.classList.contains('add_fadeInUp') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInUp');
                element.className += ' fadeInUp  show';
            }
        });
        os.on('enter', '.add_fadeInRight ', (element) => {
            if (element.classList.contains('add_fadeInRight') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInRight');
                element.className += ' fadeInRight  show';
            }
        });

        os.on('enter', '.add_fadeInLeft ', (element) => {
            if (element.classList.contains('add_fadeInLeft') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInLeft');
                element.className += ' fadeInLeft  show';
            }
        });

        os.on('enter', '.js-highlights__box__inner__item__image ', (element) => {
            if (!element.classList.contains('js-highlights__box__inner__item__image--active')) {
                element.className += ' js-highlights__box__inner__item__image--active';
            }
        });

        post_height('.js-services__box__item__title');
        post_height('.js-other__services__box__item__title');
        post_height('.js-services__box__item__text');
        post_height('.js-other__services__box__item__text');
        post_height2('.highlights__box__inner__item h3');
    },
    finalize() {
    },
};

function post_height($element) {
    $($element).removeAttr('style');
    setTimeout(function () {
        var maxheight = 0;
        $($element).each(function () {
            if ($(this).height() > maxheight) {
                maxheight = $(this).height();
            }
        });

        $($element).css('min-height', maxheight + 'px');
    }, 200);
}

function post_height2($element) {
    $($element).removeAttr('style');
    setTimeout(function () {
        var maxheight = 0;
        $($element).each(function () {
            if ($(this).height() > maxheight) {
                maxheight = $(this).height();
            }
        });
        $($element).each(function () {
            var diff = maxheight - $(this).height();
            $(this).css('margin-bottom', diff + parseInt($(this).css('margin-bottom')) + 'px');
        });


    }, 200);
}


// WEBPACK FOOTER //
// ./scripts/routes/single-services.js